import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { lsGet, lsSet } from "@/lib/storage";

export default function AgeGate({ children }) {
  const [verified, setVerified] = useState(null);

  useEffect(() => {
    setVerified(lsGet("afrodite_age_verified") === "true");
  }, []);

  const confirm = () => {
    setVerified(true);
    lsSet("afrodite_age_verified", "true");
  };
  const reject = () => { window.location.href = "https://www.google.com"; };

  if (verified === null) return <div className="min-h-screen bg-[#0B0A0C]" />;

  return (
    <>
      {children}
      <AnimatePresence>
        {!verified && (
          <motion.div
            data-testid="age-gate-overlay"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/95"
            style={{ backdropFilter: "blur(24px)" }}
          >
            <div className="absolute inset-0 vignette pointer-events-none" />
            <motion.div
              initial={{ scale: 0.94, y: 20, opacity: 0 }}
              animate={{ scale: 1, y: 0, opacity: 1 }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="relative w-full max-w-lg glass border border-[#D4AF37]/25 rounded-2xl p-8 sm:p-10 text-center shadow-2xl"
            >
              <div className="flex justify-center mb-6">
                <div className="w-16 h-16 rounded-full border border-[#D4AF37]/40 flex items-center justify-center glow-pulse">
                  <ShieldCheck className="w-7 h-7 text-[#D4AF37]" />
                </div>
              </div>
              <p className="overline mb-3">Accesso Riservato</p>
              <h1 className="font-display text-3xl sm:text-4xl leading-tight mb-5 gold-text">
                Solo per Maggiori di 18 Anni
              </h1>
              <p className="text-sm text-[#A39E9B] leading-relaxed mb-8">
                I contenuti e i servizi di <span className="text-[#FBF8F5]">Afrodite Club Privé &amp; Spa Naturista</span> sono
                dedicati esclusivamente a un pubblico adulto, nel totale rispetto della privacy e del consenso.
                Confermando dichiari di avere almeno 18 anni.
              </p>
              <div className="flex flex-col gap-3">
                <button
                  data-testid="age-gate-confirm-btn"
                  onClick={confirm}
                  className="w-full py-3.5 rounded-full bg-[#7A1426] hover:bg-[#941B30] text-[#FBF8F5] font-semibold tracking-wide transition-colors duration-300 border border-[#D4AF37]/30"
                >
                  Ho almeno 18 anni — Accedi
                </button>
                <button
                  data-testid="age-gate-reject-btn"
                  onClick={reject}
                  className="w-full py-3 rounded-full text-[#A39E9B] hover:text-[#FBF8F5] text-sm transition-colors"
                >
                  Abbandona il sito
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
